/* eslint-disable arrow-body-style */
import React from 'react';
import { TextField, Stack, Typography, MenuItem } from '@mui/material';

const ClientInfoSection = ({ formik, clients, onClientChange, onFieldBlur }) => {
  return (
    <>
      <TextField
        id="client_id"
        name="client_id"
        label="Client"
        select
        value={formik.values.client_id}
        onChange={onClientChange}
        onBlur={() => onFieldBlur('client_id')}
        error={formik.touched.client_id && Boolean(formik.errors.client_id)}
        helperText={formik.touched.client_id && formik.errors.client_id}
      >
        {clients?.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {client.practice_name}
          </MenuItem>
        ))}
      </TextField>

      {formik.values.client_id && (
        <div
          style={{
            backgroundColor: '#f5f5f5',
            padding: '16px',
            borderRadius: '8px',
            marginTop: '8px',
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Client Information
          </Typography>
          <Stack spacing={2}>
            <TextField
              id="covered_entity"
              name="covered_entity"
              label="Covered Entity"
              value={formik.values.covered_entity}
              onChange={formik.handleChange}
              onBlur={() => onFieldBlur('covered_entity')}
              error={formik.touched.covered_entity && Boolean(formik.errors.covered_entity)}
              helperText={formik.touched.covered_entity && formik.errors.covered_entity}
              size="small"
            />
            <TextField
              id="practice_name"
              name="practice_name"
              label="Practice Name"
              value={formik.values.practice_name}
              onChange={formik.handleChange}
              onBlur={() => onFieldBlur('practice_name')}
              error={formik.touched.practice_name && Boolean(formik.errors.practice_name)}
              helperText={formik.touched.practice_name && formik.errors.practice_name}
              size="small"
            />
            <TextField
              id="phone"
              name="phone"
              label="Phone"
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={() => onFieldBlur('phone')}
              error={formik.touched.phone && Boolean(formik.errors.phone)}
              helperText={formik.touched.phone && formik.errors.phone}
              size="small"
            />
            <TextField
              id="address"
              name="address"
              label="Address"
              multiline
              rows={2}
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={() => onFieldBlur('address')}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
              size="small"
            />
          </Stack>
        </div>
      )}
    </>
  );
};

export default ClientInfoSection;
